import $ from 'jquery'
import 'dotdotdot'
import '../plugins/jquery.viewport'
import inViewport from 'in-viewport'

$('.product .multiline').dotdotdot({
  ellipsis: ' ...',
  wrap: 'word',
  height: 40
});


function fetchProducts(url, page) {
  $.ajax({
    url: url,
    type: "GET",
    dataType: "json",
    data: `pageNumber=${page}`,
    success: (response) => {
      if (response.html) {
        let products = $('<div class="new"></div>').html(response.html);
        products.insertBefore('.products footer');
        setTimeout(() => {
          $('.products footer').removeClass('loading');
          products.addClass('show');
        }, 500);
      }

      if (response.nextPage) {
        $('.ajax-load-products').data('nextpage', response.nextPage);
      } else {
        $('.products footer').addClass('done');
      }
      $(window).trigger('contentchanged');
    },
    error: (xhr, ajaxOptions, thrownError) => {
      $('.products footer').removeClass('loading').addClass('done');
      console.log("error", xhr.status, thrownError);
    }
  });
}


$('.ajax-load-products').on('click', (e) => {
  e.preventDefault();
  $('.products footer').addClass('loading');
  let nextPage = $(e.target).data('nextpage');
  fetchProducts(e.target.href, nextPage);
});


$(window).on('scroll', () => {
  let element = $(".ajax-load-products");
  let offset = element.data('offset') || 0;
  element.length && inViewport(element[0], {offset: Number(offset)}, () => {
    let button = $('.ajax-load-products');
    let nextPage = button.data('nextpage');

    if (!$('.products footer').hasClass('done') || !$('.products footer').hasClass('loading')) {
      $('.products footer').addClass('loading');
      fetchProducts(button[0].href, nextPage);
    }
  });
});



// WEBPACK FOOTER //
// ./src/js/components/products.js